import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../auth.service";
import * as i2 from "../../../services/lcp/lcp.service";
export class ProductsResolverService {
    constructor(auth, lcpService) {
        this.auth = auth;
        this.lcpService = lcpService;
    }
    resolve(route) {
        console.log('Fetching Accounts in route resolver...', route);
        //
        // When it's ready for the forkJoin... test more error handling
        //
        // const claimsRBS$ = this.auth.rbsClaims();
        // const account$ = this.lcpService.getAccounts();
        // return forkJoin([claimsRBS$,account$])
        //
        // Make Claims Identify
        //
        this.auth.rbsClaims()
            .subscribe(res => {
            console.log('this.auth.rbsClaims() : ' + JSON.stringify(res));
        });
        //
        // getAccounts()
        //
        return this.lcpService.getAccounts().pipe(catchError(error => {
            return of(error);
        }));
        //
        // Just to flag the workflow through
        //
        // let data = {
        //     Username : 'batman.co',
        //     SupportUsername : null,
        //     FortifyUserSourceType: 2,
        //     Accounts: [
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM HUNT/CLAYCO JV (A) TEST DATABASE - FEDERAL","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
        //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
        //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
        //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
        //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true}
        //       ]
        // }
        //  return of(data);
    }
}
ProductsResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProductsResolverService_Factory() { return new ProductsResolverService(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.LcpService)); }, token: ProductsResolverService, providedIn: "root" });
